import { render } from "./CLOUDFLARE_D1.vue?vue&type=template&id=7a48f920"
import script from "./CLOUDFLARE_D1.vue?vue&type=script&lang=js"
export * from "./CLOUDFLARE_D1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/data-adapter/CLOUDFLARE_D1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a48f920"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a48f920', __exports__)) {
    api.reload('7a48f920', __exports__)
  }
  
  module.hot.accept("./CLOUDFLARE_D1.vue?vue&type=template&id=7a48f920", () => {
    api.rerender('7a48f920', render)
  })

}


export default __exports__